import { css } from "styled-components";
import { mediaPromoSizes } from "../../../../../../blades/MediaPromo";
import { RichText } from "../../../../../../components/RichText";
import { textUppercaseMixin } from "../../../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    color: ${paletteTokens.bladetext1};
    padding: calc(${chroma.spacers.variable.m} * 2.5) 0;
    display: flex;
    min-height: ${mediaPromoSizes.minHeightDesktop};

    ${chroma.mediaQueries.tabletDown} {
      min-height: ${mediaPromoSizes.minHeightTablet};
    }

    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileImage};
      flex-direction: column-reverse;
    }
  }

  &:not(.backdrop-exist) {
    background-color: ${paletteTokens.bladebg1};
  }

  &:is(.backdrop-exist) {
    background-color: transparent;
  }

  &:not(.layout-no-image) {
    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileImage};
    }
  }

  &:is(.layout-no-image) {
    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileNoImage};
    }
  }

  .blade-content {
    align-self: center;
  }

  .content-no-image {
    ${chroma.mediaQueries.mobileDown} {
      align-self: flex-end;
    }
  }

  .main-container {
    display: flex;
    align-items: center;
    justify-content: center;

    ${chroma.mediaQueries.mobileDown} {
      padding: calc(${chroma.spacers.variable.m} * 2.5) 0;
      flex-direction: column;
    }
  }

  .wo-image {
    ${chroma.mediaQueries.mobileDown} {
      justify-content: flex-end;
      align-items: flex-start;
    }
  }

  .left-container {
    flex: 0 1 50%;
    max-width: 50%;
    min-height: 100%;
    padding-right: ${chroma.spacers.variable.m};

    ${chroma.mediaQueries.tabletDown} {
      padding-right: calc(${chroma.spacers.variable.m} + 4px);
    }

    ${chroma.mediaQueries.mobileDown} {
      max-width: 100%;
      padding-right: 0;
      padding-bottom: calc(${chroma.spacers.variable.m} - 4px);
      padding-top: calc(${chroma.spacers.variable.m} - 4px);
    }
  }

  .right-container {
    flex: 0 1 50%;
    max-width: 50%;
    min-height: 100%;
    padding-left: ${chroma.spacers.variable.m};

    ${chroma.mediaQueries.tabletDown} {
      padding-left: calc(${chroma.spacers.variable.m} + 4px);
    }

    ${chroma.mediaQueries.mobileDown} {
      min-width: 100%;
      padding-left: 0;
    }
  }

  .title {
    ${textUppercaseMixin};
    ${chroma.typography.display3};
    padding-bottom: calc(${chroma.spacers.variable.m} / 2);

    ${chroma.mediaQueries.tabletDown} {
      padding-bottom: ${chroma.spacers.variable.m};
    }
  }

  .description ${RichText} {
    ${chroma.typography.body3};
    font-weight: normal;
    padding-bottom: calc(${chroma.spacers.variable.m} / 2);

    ${chroma.mediaQueries.tabletDown} {
      padding-bottom: ${chroma.spacers.variable.m};
    }
  }
`;
//# sourceMappingURL=index.js.map